"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.67 8.708a.7.7 0 0 1-.595.792c-1.294.184-2.35.48-3.06.827-.356.174-.593.345-.731.491-.136.143-.142.223-.142.244v7.778c0 .026.016.168.32.403.295.227.766.461 1.41.67 1.28.418 3.094.687 5.128.687s3.848-.27 5.128-.686c.644-.21 1.115-.444 1.41-.671.304-.235.32-.377.32-.403v-7.778c0-.02-.006-.1-.141-.244-.139-.146-.375-.317-.732-.49-.71-.347-1.766-.644-3.06-.828a.7.7 0 0 1 .197-1.386c1.376.195 2.588.521 3.477.955.444.217.84.476 1.135.787.298.316.524.723.524 1.206v7.778c0 .653-.406 1.158-.866 1.512-.47.362-1.107.658-1.83.893C16.105 21.72 14.14 22 12 22s-4.106-.281-5.561-.755c-.724-.235-1.36-.53-1.83-.893-.46-.354-.867-.859-.867-1.512v-7.778c0-.483.226-.89.524-1.206.295-.311.692-.57 1.135-.787.89-.434 2.102-.76 3.477-.955a.7.7 0 0 1 .792.594",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.442 10.362a.7.7 0 0 1 .7.7c0 .026.016.169.32.403.295.227.766.462 1.41.671 1.28.417 3.094.686 5.128.686s3.848-.27 5.128-.686c.644-.21 1.115-.444 1.41-.671.304-.234.32-.377.32-.403a.7.7 0 1 1 1.4 0c0 .654-.406 1.158-.866 1.513-.47.361-1.107.657-1.83.892-1.456.474-3.422.755-5.562.755s-4.106-.281-5.561-.755c-.724-.235-1.36-.53-1.83-.893-.46-.354-.867-.858-.867-1.512a.7.7 0 0 1 .7-.7m0 3.936a.7.7 0 0 1 .7.7c0 .027.016.169.32.403.295.227.766.462 1.41.671 1.28.417 3.094.687 5.128.687s3.848-.27 5.128-.687c.644-.21 1.115-.444 1.41-.67.304-.235.32-.377.32-.404a.7.7 0 1 1 1.4 0c0 .654-.406 1.159-.866 1.513-.47.362-1.107.657-1.83.893-1.456.473-3.422.755-5.562.755s-4.106-.282-5.561-.755c-.724-.236-1.36-.531-1.83-.893-.46-.354-.867-.86-.867-1.513a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.51 2.2a.7.7 0 0 1 .98 0l3.024 2.968a.7.7 0 1 1-.98.999l-1.834-1.8v6.424a.7.7 0 1 1-1.4 0V4.368L9.467 6.167a.7.7 0 0 1-.98-1z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=UploadDatatableIcon24.js.map